import support from "./support.js";

export default {
  getEpaperList(){
    return support.get("Epaper/getEpaperList");
  },

  saveEpaper(data) {
    return support.post("Epaper/saveEpaper", data);
  },

  getEpaper(uid) {
    return support.get("Epaper/getEpaper/" + uid);
  }
}
